// UI mapping for the deadline state computed by the backend.
// `color` / `ring` are the timeline dot fill and stroke; `legend` overrides the label in the
// timeline legend; `hideInLegend` drops a state that shares its colour with another one.
export const DEADLINE_STATES = {
  upcoming:      { label: 'Upcoming',          color: '#ffffff', ring: '#adb5bd' },
  queued:        { label: 'In queue',          color: '#fd7e14', ring: '#ffffff' },
  passed:        { label: 'Passed',            color: '#198754', ring: '#ffffff' },
  failed:        { label: 'Failed',            color: '#dc3545', ring: '#ffffff',
                   legend: 'Failed / no submission' },
  error:         { label: 'Internal error',    color: '#ffffff', ring: '#842029' },
  not_evaluated: { label: 'Not evaluated yet', color: '#ced4da', ring: '#ffffff' },
  // Nothing submitted and the deadline is over: counts as failed (red), the tooltip says why
  no_submission: { label: 'No submission',     color: '#dc3545', ring: '#ffffff',
                   hideInLegend: true },
};
